export default __webpack_public_path__ + "static/media/ks012-3599-00.4fcf57f1.jpg";